import axiosInstance from '../axiosInterceptor/axiosInstance'
import eventCollection from '../../utils/helpers/eventHelpers/eventCollection'

const updateEvent = async (data) => {
  const { formData, eventId, eventType, orgId } = data
  const url = `v1/orgs/${orgId}/events/${eventCollection(eventType.code)}/${eventId}`
  return axiosInstance.patch(url, formData)
}

export default updateEvent
